import React, { useEffect, useState } from 'react';

import styles from './StatisticsHealth.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import HealthCardHdPopulation from './HealthCards/HealthCardHdPopulation/HealthCardHdPopulation';
import HealthCardHdPercentage from './HealthCards/HealthCardHdPercentage/HealthCardHdPercentage';
import HealthCardHdindexAverage from './HealthCards/HealthCardHdindexAverage/HealthCardHdindexAverage';
import HealthCardAdDistributionYear from './HealthCards/HealthCardAdDistributionYear/HealthCardAdDistributionYear';
import HealthCardGlaukomDistributionYear from './HealthCards/HealthCardGlaukomDistributionYear/HealthCardGlaukomDistributionYear';
import HealthCardAtaksiDistributionYear from './HealthCards/HealthCardAtaksiDistributionYear/HealthCardAtaksiDistributionYear';
import HealthCardDwarfDistributionYear from './HealthCards/HealthCardDwarfDistributionYear/HealthCardDwarfDistributionYear';

function StatisticsHealth(props: StatisticsHealthProps) {

    const [hasDataHdPopulation, setHasDataHdPopulation] = useState<boolean>(false);
    const [hasDataHdIndexAverage, setHasDataHdIndexAverage] = useState<boolean>(false);
    const [hasDataHdPercentage, setHasDataHdPercentage] = useState<boolean>(false);
    const [hasDataAdDistributionYear, setHasDataAdDistributionYear] = useState<boolean>(false);
    const [hasDataGlaukomDistributionYear, setHasDataGlaukomDistributionYear] = useState<boolean>(false);
    const [hasDataAtaksiDistributionYear, setHasDataAtaksiDistributionYear] = useState<boolean>(false);
    const [hasDataDwarfDistributionYear, setHasDataDwarfDistributionYear] = useState<boolean>(false);

    useEffect(() => {
        props.onDataLoaded?.(
            hasDataHdPopulation ||
            hasDataHdIndexAverage ||
            hasDataHdPercentage ||
            hasDataAdDistributionYear ||
            hasDataGlaukomDistributionYear ||
            hasDataAtaksiDistributionYear ||
            hasDataDwarfDistributionYear
        );
    }, [
        hasDataHdPopulation,
        hasDataHdIndexAverage,
        hasDataHdPercentage,
        hasDataAdDistributionYear,
        hasDataGlaukomDistributionYear,
        hasDataAtaksiDistributionYear,
        hasDataDwarfDistributionYear
    ]);

    return (
        <div className={styles.statisticshealth}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataHdPopulation
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardHdPopulation
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataHdPopulation(true);
                                } else {
                                    setHasDataHdPopulation(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataHdIndexAverage
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardHdindexAverage
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataHdIndexAverage(true);
                                } else {
                                    setHasDataHdIndexAverage(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataHdPercentage
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardHdPercentage
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataHdPercentage(true);
                                } else {
                                    setHasDataHdPercentage(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataAdDistributionYear
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardAdDistributionYear
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataAdDistributionYear(true);
                                } else {
                                    setHasDataAdDistributionYear(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataGlaukomDistributionYear
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardGlaukomDistributionYear
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataGlaukomDistributionYear(true);
                                } else {
                                    setHasDataGlaukomDistributionYear(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataAtaksiDistributionYear
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardAtaksiDistributionYear
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataAtaksiDistributionYear(true);
                                } else {
                                    setHasDataAtaksiDistributionYear(false);
                                }
                            }}
                        />
                    </Col>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataDwarfDistributionYear
                                ? "block" : "none"
                        }}
                    >
                        <HealthCardDwarfDistributionYear
                            onDataLoaded={(data) => {
                                if (data.length != 0) {
                                    setHasDataDwarfDistributionYear(true);
                                } else {
                                    setHasDataDwarfDistributionYear(false);
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

class StatisticsHealthProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default StatisticsHealth;